export default {
  companyName: {
    component: 'adivare-generic-cancellation-typeahead',
    translationKey: 'companyName',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full',
    colSpan: 6,
  },
  companyAddress: {
    component: 'adivare-default-form-element',
    formType: 'text',
    translationKey: 'companyAddress',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full',
    colSpan: 6,
  },
  companyPostcode: {
    component: 'adivare-postcode-form-element',
    formType: 'text',
    translationKey: 'companyPostcode',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full',
    colSpan: 6,
  },
  companyCity: {
    component: 'adivare-default-form-element',
    formType: 'text',
    translationKey: 'companyCity',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full',
    colSpan: 6,
  },
  companySubscriptionName: {
    component: 'adivare-default-form-element',
    formType: 'text',
    translationKey: 'companySubscriptionName',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full',
    colSpan: 6,
  },
};
